//Local

// export enum InwardStatus{
//     Returnable = 12,
//     NonReturnable = 13,
//     Created = 17,
//     Checked = 14,
//     ChallanUploaded = 16,
//     Cancelled = 15,
//     Declined = 18,
//     Received = 19
// }

//Dev

export enum InwardStatus{
    Returnable = 13,
    NonReturnable = 14,
    InternalMovement = 22,
    Created = 18,
    Checked = 15,
    Collected = 21,
    ChallanUploaded = 17,
    Cancelled = 16,
    Declined = 19,
    Received = 20
}